import React, { useState } from 'react';
import { useOptimizedImages } from 'common/hooks/use-optimized-images';

type ImagePlaceholderType = {
  alt?: string;
  src?: string;
  className: string;
  fallback: React.ReactNode;
};

export const ImagePlaceholder: React.FC<ImagePlaceholderType> = ({ src, alt, className, fallback }) => {
  const [isError, setIsError] = useState(false);

  const optimizedThumbImage = useOptimizedImages(
    src,
    {
      rest: {
        h: '80',
        w: '80',
      },
    },
    {
      b: 'transparent',
      c: 'pad',
    },
  );

  if (isError && fallback) {
    return <>{fallback}</>;
  }

  return (
    <img
      alt={alt}
      src={optimizedThumbImage.rest?.x || ''}
      srcSet={`${optimizedThumbImage.rest?.xx} 2x`}
      className={className}
      data-qa="image-placeholder"
      onError={() => setIsError(true)}
    />
  );
};
